module.exports = __webpack_public_path__ + "static/media/exercise_card_bg.49df6685.jpg";